import React, { useEffect } from "react";

export default function AdsterraAdvertise() {
  useEffect(() => {
    // ✅ Helper function to inject HighPerformanceFormat ad
    const loadHighPerformanceAd = (containerId) => {
      const optionsScript = document.createElement("script");
      optionsScript.type = "text/javascript";
      optionsScript.innerHTML = `
        atOptions = {
          'key' : '068ccabd7477e7e030c1ab6c2c82a381',
          'format' : 'iframe',
          'height' : 250,
          'width' : 300,
          'params' : {}
        };
      `;

      const invokeScript = document.createElement("script");
      invokeScript.type = "text/javascript";
      invokeScript.src =
        "//www.highperformanceformat.com/068ccabd7477e7e030c1ab6c2c82a381/invoke.js";

      const container = document.getElementById(containerId);
      if (container) {
        container.appendChild(optionsScript);
        container.appendChild(invokeScript);
      }
    };

    // ✅ Helper function to inject EffectiveGateCPM ad
    const loadEffectiveGateAd = (containerId) => {
      const script = document.createElement("script");
      script.async = true;
      script.setAttribute("data-cfasync", "false");
      script.src =
        "//pl27838283.effectivegatecpm.com/985b7d60ddff127b8b181fbaf87dc6dd/invoke.js";

      const container = document.getElementById(containerId);
      if (container) {
        container.appendChild(script);
      }
    };

    // ✅ Load HighPerformanceFormat ads (3 times — no loop)
    loadHighPerformanceAd("ad-container-1");
    loadHighPerformanceAd("ad-container-2");
    loadHighPerformanceAd("ad-container-3");

    // ✅ Load EffectiveGateCPM ad
    loadEffectiveGateAd("container-985b7d60ddff127b8b181fbaf87dc6dd");
  }, []);

  return (
    <div className="container my-4 text-center">
      {/* Three HighPerformanceFormat Ads */}
      {/* <div id="ad-container-1" className="mb-3"></div>
      <div id="ad-container-2" className="mb-3"></div>
      <div id="ad-container-3" className="mb-3"></div> */}

      {/* EffectiveGateCPM Ad */}
      <div id="container-985b7d60ddff127b8b181fbaf87dc6dd" className="mt-4"></div>
    </div>
  );
}
